import Select from '@mui/material/Select';
import { alpha, styled } from '@mui/material/styles';

/** Select tinted with the brand color while it holds a value. */
export const ActiveTintSelect = styled(Select, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  ...(active && { backgroundColor: alpha(theme.palette.primary.main, 0.08) }),
}));
